// eslint-disable-next-line no-unused-vars
import React, { useEffect, useRef } from "react";
import effectsConfig from "../effects/effectsConfig"; // Steuerung der Effekte

const Snowfall = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!effectsConfig.snowfall) return; // ❄ Falls deaktiviert, beende den Effekt sofort

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let width = (canvas.width = window.innerWidth);
    let height = (canvas.height = window.innerHeight);
    const numFlakes = 100;
    const flakes = [];

    class Snowflake {
      constructor() {
        this.x = Math.random() * width;
        this.y = Math.random() * height;
        this.size = Math.random() * 3 + 1;
        this.speedY = Math.random() * 1.5 + 0.5;
        this.speedX = Math.random() * 1 - 0.5;
        this.opacity = Math.random() * 0.8 + 0.2;
      }

      update() {
        this.y += this.speedY;
        this.x += this.speedX;

        if (this.y > height) {
          this.y = -this.size;
          this.x = Math.random() * width;
        }
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${this.opacity})`;
        ctx.fill();
      }
    }

    const createFlakes = () => {
      for (let i = 0; i < numFlakes; i++) {
        flakes.push(new Snowflake());
      }
    };

    const animateSnow = () => {
      ctx.clearRect(0, 0, width, height);
      flakes.forEach((flake) => {
        flake.update();
        flake.draw();
      });
      requestAnimationFrame(animateSnow);
    };

    createFlakes();
    animateSnow();

    const resize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
      ctx.clearRect(0, 0, width, height);
    };
  }, []);

  return effectsConfig.snowfall ? ( // ❄ Schneefall nur anzeigen, wenn aktiviert
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 2, // ❄ Sicherstellen, dass Buttons klickbar bleiben
      }}
    />
  ) : null;
};

export default Snowfall;
